import links from "@/links/links";
import qs from "qs";
import moment from "moment";

import { meetingStatuses } from "@/constants/meeting.js";

export default {
  actions: {
    GET_WITH_RELATED_MEDIA(id) {
      return this.get(links.MEETING_WITH_RELATED_MEDIA(id), { save: false });
    },
    // NOTE: HACK: get with related building, meeting_resolutions (might be needed to be persisted to store separately)
    //       + custom filter: "*meetings-building-name*"
    //       + custom sort by: "*meetings-building-name*" & "*meetings-no-resolutions*" (see code in middlewares)
    QUERY_FETCH(queryParams, properties) {
      // NOTE: prepare query params
      var processedQueryParams = {};
      // filters
      queryParams.filter.forEach(filter => {
        if (filter.column == "*meetings-building-name*") {
          processedQueryParams["building"] = filter.value;
        } else if (filter.column == "meeting_date") {
          // HACK: after start of day - before end of day (transform from local to UTC)
          var startOfDay = moment(filter.value).startOf("day").format("YYYY-MM-DDTHH:mm:ssZ");
          var endOfDay = moment(filter.value).endOf("day").format("YYYY-MM-DDTHH:mm:ssZ");

          var startOfDayUTC = moment.utc(startOfDay).format("YYYY-MM-DD HH:mm:ss");
          var endOfDayUTC = moment.utc(endOfDay).format("YYYY-MM-DD HH:mm:ss");

          processedQueryParams["meeting_date[after]"] = startOfDayUTC;
          processedQueryParams["meeting_date[before]"] = endOfDayUTC;
        } else {
          processedQueryParams[filter.column] = filter.value;
        }
      });
      // order
      if (queryParams.sort.by == "*meetings-building-name*") {
        processedQueryParams[`order[building.name]`] = queryParams.sort.dir.toLowerCase();
      } else if (queryParams.sort.by == "*meetings-no-resolutions*") {
        // TODO: ...
      } else {
        processedQueryParams[`order[${queryParams.sort.by}]`] = queryParams.sort.dir.toLowerCase();
      }
      // page
      processedQueryParams.page = queryParams.page;
      processedQueryParams.itemsPerPage = queryParams.itemsPerPage;

      let propertiesString = "";
      properties.forEach(prop => {
        if (typeof prop == "string") {
          propertiesString += `&properties[]=${prop}`;
        } else if (typeof prop == "object") {
          for (const [key, values] of Object.entries(prop)) {
            for (const value of values) {
              propertiesString += `&properties[${key}][]=${value}`;
            }
          }
        }
      });

      return this.get(links.MEETING_QUERY_FETCH(propertiesString), {
        params: processedQueryParams,
        paramsSerializer: params => {
          return qs.stringify(params);
        },
        dataKey: "hydra:member",
      });
    },
    GET(id) {
      return this.get(links.MEETING_GET(id));
    },
    GET_DOCUMENTS(id) {
      return this.get(links.MEETING_GET_DOCUMENTS(id));
    },
    MEETING_SEND_NOTIFICATIONS(itemId) {
      return this.post(links.MEETING_SEND_NOTIFICATIONS(), {
        meetingId: itemId,
      });
    },
    POST(item) {
      return this.post(links.MEETING_POST(), item);
    },
    PUT(item, save) {
      return this.put(links.MEETING_PUT(item.id), item, { save: save });
    },
    DELETE(item, doZipBackup) {
      return this.get(links.MEETING_DELETE(item.id, doZipBackup));
    },
    CREATE_MANDATES_FOR_MEETING(meeting) {
      return this.post(links.CREATE_MANDATES_FOR_MEETING(), { "meeting-id": meeting.id }).then(
        () => {
          this.model.update({
            where: meeting.id,
            data: {
              status: meetingStatuses.mandatesCreated,
            },
          });
        }
      );
    },
    // FIXME: ??????? GET?
    MEETING_INVITATION_READY_TO_SEND(meetingId) {
      return this.get(links.MEETING_INVITATION_READY_TO_SEND(meetingId), {
        save: false,
      });
    },
    MEETING_DUPLICATE(item) {
      return this.post(links.MEETING_DUPLICATE(), item);
    },
    START(meeting) {
      return this.put(links.MEETING_START(meeting.id), meeting);
    },
    RESET(meeting) {
      return this.put(links.MEETING_RESET(meeting.id), meeting);
    },
    GET_BY_BUILDING(buildingId) {
      return this.get(links.MEETINGS_GET_BY_BUILDING(buildingId), {
        dataKey: "hydra:member",
      });
    },
    MEETING_RESOLUTION_STATUS_NOT_VOTED(meeting) {
      return this.put(
        links.MEETINGS_UPDATE_MEETING_RESOLUTION_STATUS_NOT_VOTED(meeting.id),
        meeting
      );
    },
    ARCHIVE(item, userMediaId) {
      return this.get(links.MEETING_ARCHIVE(item.id, userMediaId));
    },
    // It's done from meeting entity
    REGISTER_DETAILS(meetingId) {
      return this.get(links.MEETING_MEETING_REGISTER() + `/${meetingId}`);
    },
    UPDATE_DOCS_PRINT_COLOR(meeting) {
      return this.put(links.MEETING_UPDATE_DOCS_PRINT_COLOR(meeting.id), meeting, { save: false });
    },
    UPDATE_CURRENT_RESOLUTION(meeting) {
      return this.put(links.MEETING_UPDATE_CURRENT_RESOLUTION(meeting.id), meeting, {
        save: false,
      });
    },
    UPDATE_MINUTES(meeting) {
      return this.put(links.MEETING_UPDATE_MINUTES(meeting.id), meeting, {
        save: false,
      });
    },
  },
};
